export default __webpack_public_path__ + "static/media/march-2019.fca72b7d.csv";